// Cohedron specific icons

export const AnchorIcon = () => (
    <div className="group-hover:scale-125 transition-all duration-200 ease-in-out">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
            <path
                d="M2.34806 0.703992C2.11004 0.570324 1.84003 0.499968 1.56519 0.5C1.29035 0.500032 1.02036 0.570449 0.782366 0.704172C0.544377 0.837895 0.346779 1.03021 0.209442 1.26178C0.0721049 1.49334 -0.000130281 1.756 1.76393e-07 2.02334V11.9767C-0.000130281 12.244 0.0721049 12.5067 0.209442 12.7382C0.346779 12.9698 0.544377 13.1621 0.782366 13.2958C1.02036 13.4296 1.29035 13.5 1.56519 13.5C1.84003 13.5 2.11004 13.4297 2.34806 13.296L11.2167 8.31935C11.4548 8.18575 11.6526 7.99352 11.7901 7.76198C11.9276 7.53045 12 7.26777 12 7.00038C12 6.73299 11.9276 6.47031 11.7901 6.23878C11.6526 6.00724 11.4548 5.81501 11.2167 5.68142L2.34806 0.703992Z"
                fill="var(--primary)"
            />
        </svg>
    </div>
);
